export default "__VITE_ASSET__CQM5boai__"